<script lang="ts">
    import type { InstachatState, InstachatTexts } from "./instachat";
    import type { JitsiSettings } from "./jitsi";
    import JitsiVideo from "./JitsiVideo.svelte";
    import { state } from "./stores";

    export let texts: InstachatTexts;
    export let jitsi: JitsiSettings;
    const participantJitsiConfig = {
        ...jitsi,
        options: {
            ...jitsi.options,
            toolbarButtons: [
                "fullscreen",
                "hangup",
                "microphone",
                "chat",
                "select-background",
                "tileview",
            ],
        },
    };
    const getText = (state: InstachatState) => {
        switch (state) {
            case "CHAT_IS_OVER":
                return texts.chatOver;
            case "CLOSED":
                return texts.closed;
            case "OPEN":
                return texts.open;
            case "SUPERVISOR_PRESENT":
                return texts.supervisorJoined;
            case "CHAT_IS_OVER":
                return texts.chatOver;
            default:
                return "Ei tekstiä";
        }
    };
    $: text = getText($state);
</script>

<div>
    {@html text}
</div>

{#if $state === "SUPERVISOR_PRESENT"}
    <div class="video">
        <JitsiVideo jitsi={participantJitsiConfig} />
    </div>
{/if}

<style>
    .video {
        padding-top: 16px;
    }
</style>
